import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function OTPScreen() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [timer, setTimer] = useState(30);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const handleChange = (index: number, value: string) => {
    if (isNaN(Number(value))) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    // Auto focus next input
    if (value !== '' && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
    if (e.key === 'Backspace' && otp[index] === '' && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const handleVerify = () => {
    if (otp.join('').length === 6) {
      navigate('/usertype');
    }
  };
  return <div className="min-h-screen bg-ui-bg flex flex-col" data-id="element-1092">
      <div className="pt-12 px-6 pb-6" data-id="element-1093">
        <button onClick={() => navigate(-1)} className="mb-6 p-2 -ml-2 rounded-full hover:bg-ui-card active:bg-ui-border transition-colors" data-id="element-1094">
          <ArrowLeft size={24} className="text-text-main" data-id="element-1095" />
        </button>
        <h1 className="text-3xl font-bold text-text-main mb-2" data-id="element-1096">Enter code</h1>
        <p className="text-text-secondary" data-id="element-1097">
          We sent a 6-digit verification code to <br data-id="element-1098" />
          <span className="font-medium text-text-main" data-id="element-1099">+234 801 234 5678</span>
        </p>
      </div>

      <div className="px-6 flex-1" data-id="element-1100">
        <div className="flex justify-between mb-8" data-id="element-1101">
          {otp.map((digit, index) => <input key={index} ref={el => inputRefs.current[index] = el} type="text" inputMode="numeric" maxLength={1} value={digit} onChange={e => handleChange(index, e.target.value)} onKeyDown={e => handleKeyDown(index, e)} className="w-12 h-14 text-center text-2xl font-bold bg-ui-card border border-ui-border rounded-xl focus:ring-2 focus:ring-brand-primary focus:border-transparent outline-none transition-all" data-id="element-1102" />)}
        </div>

        <button onClick={handleVerify} disabled={otp.join('').length !== 6} className="w-full bg-brand-primary text-white font-semibold text-lg py-4 rounded-xl shadow-md active:scale-[0.98] transition-transform disabled:opacity-50 disabled:active:scale-100" data-id="element-1103">
          Verify
        </button>

        <div className="mt-8 text-center" data-id="element-1104">
          <p className="text-text-secondary text-sm" data-id="element-1105">
            Didn't receive the code?{' '}
            {timer > 0 ? <span className="font-medium" data-id="element-1106">Resend in {timer}s</span> : <button className="font-medium text-brand-primary active:opacity-70" data-id="element-1107">
                Resend now
              </button>}
          </p>
        </div>
      </div>
    </div>;
}